<!--
* @Description: 学生请假记录 详情
* @Author: ZSC
* @Date: 2023-03-22 16:51:09.813
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-06-07 16:32:25
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="学生" label-align="right" align="left" width="120px" span="2">{{ruleForm.xm}}</el-descriptions-item>
        <el-descriptions-item label="请假开始时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.qjkssj}}</el-descriptions-item>
        <el-descriptions-item label="请假结束时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.qjjssj}}</el-descriptions-item>
        <el-descriptions-item label="请假天数" label-align="right" align="left" width="120px" span="2">{{ruleForm.qjts}}</el-descriptions-item>
        <el-descriptions-item label="请假类型" label-align="right" align="left" width="120px" span="2">{{ruleForm.qjlxmc}}</el-descriptions-item>
        <el-descriptions-item label="请假原因" label-align="right" align="left" width="120px" span="2">{{ruleForm.qjyy}}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/jiaowu/xueshengqingjiajilu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
